<template>
  <!-- 키워드 룰 카드 — 컨트롤 한 줄(토글·라벨·리액션·더보기) + 하단(키워드 입력 + 태그 칩 캐러셀). -->
  <div :id="rule.id" class="rule-card" :class="{ 'rule-card--dark': isDark }">
    <!-- 컨트롤 행: 활성 토글(좌) → 라벨 → 리액션 선택 → 더보기 -->
    <div class="rule-row">
      <app-switch
        square
        :value="rule.isEnabled"
        class="rule-row__switch"
        @input="$emit('toggle-enabled', $event)"
      ></app-switch>

      <StyledKeyword color="#5932a3" class="rule-row__label">{{ rule.label }}</StyledKeyword>

      <InstructionSelector
        class="rule-row__select"
        :value="rule.reactionId"
        hide-details
        dense
        @change="$emit('change-instruction', $event)"
        @play="$emit('play', $event)"
      ></InstructionSelector>

      <v-spacer></v-spacer>

      <!-- 더보기(⋮): 수정하기 / 삭제하기 -->
      <app-menu
        :items="[
          { label: '수정하기', icon: 'mdi-pencil', value: 'edit' },
          { label: '삭제하기', icon: 'mdi-delete', color: 'error', value: 'delete' },
        ]"
        @select="$emit($event)"
      ></app-menu>
    </div>

    <!-- 하단: 키워드 입력(좌) + 태그(키워드) 칩 캐러셀(넘치면 가로 스크롤) -->
    <div class="rule-bottom">
      <div class="rule-bottom__input">
        <KeywordInput hide-details dense @add="$emit('add-word', $event)"></KeywordInput>
      </div>
      <div class="rule-chips">
        <KeywordChips :keywords="rule.keywords" @clickRemove="$emit('remove-word', $event)"></KeywordChips>
      </div>
    </div>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
// StyledKeyword · InstructionSelector 는 전역 auto-register (src/components). KeywordChips/KeywordInput 만 명시 import.
import KeywordChips from "../components/KeywordChips.vue";
import KeywordInput from "../components/KeywordInput.vue";

export default {
  name: "KeywordRuleCard",
  components: { KeywordChips, KeywordInput },
  mixins: [Themeable], // isDark(앱 테마/컨텍스트 상속) + dark/light prop 오버라이드
  props: {
    // { id, label, isEnabled, isMentionMode, reactionId, keywords[] }
    rule: { type: Object, required: true },
  },
};
</script>

<style scoped>
.rule-card {
  padding: 8px 12px;
  margin-bottom: 8px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.rule-card--dark {
  background: #23232f;
  border-color: #2f2f3d;
}

.rule-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.rule-row__switch,
.rule-row__select {
  flex-shrink: 0;
}
/* 라벨(StyledKeyword) 폰트 축소 → padding(em)도 같이 줄어 높이가 다른 요소와 맞음 */
.rule-row__label {
  flex-shrink: 0;
  font-size: 12px;
}

.rule-bottom {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.rule-bottom__input {
  width: 160px;
  flex-shrink: 0;
}

/* 태그 칩 캐러셀 — 넘치면 가로 스크롤 (내부 KeywordChips는 d-flex nowrap) */
.rule-chips {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
}
.rule-chips >>> .d-flex {
  flex-wrap: nowrap;
  width: max-content;
}
.rule-chips::-webkit-scrollbar {
  height: 6px;
}
.rule-chips::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.4);
  border-radius: 3px;
}
</style>
